import React from 'react';

import Card from '@mui/material/Card';
import { useNavigate } from 'react-router-dom';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

function WarranteeEditingActionCard() {
  const navigateBack = useNavigate();
  return (
    <Card sx={{ background: 'none', border: 'none', boxShadow: 'none' }}>
      <Stack
        spacing={2}
        direction='row'
        sx={{ float: 'right', margin: '15px' }}
      >
        <Button
          variant='contained'
          onClick={() => {
            navigateBack(`/warrantee`, { replace: true });
          }}
        >
          Save
        </Button>
        <Button
          variant='outlined'
          onClick={() => {
            navigateBack(`/warrantee`, { replace: true });
          }}
        >
          Cancel
        </Button>
      </Stack>
    </Card>
  );
}

export default WarranteeEditingActionCard;
